import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { Small } from 'foundations-components/transitional/components/Small';
import styled from 'foundations-theming/utils';
import { CustomError } from 'pricing-pages-lib/errors/CustomErrors';
import { getI18nText } from 'pricing-pages-lib/utils/languageUtils';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { getOnboardingServicesUrlPublic } from 'pricing-pages-lib/utils/publicPageUrls';
import { CrossedOutPrice, PriceDisplay } from 'pricing-pages-ui-components/price/PriceDisplay';
import { HUBSPOT_FOR_STARTUPS_SETUP } from 'self-service-api/constants/ApiNames';
import { usePurchaseOptionsForProductsForTerm } from '../../hooks/usePurchaseOptions';
import { trackClickedLink } from '../../utils/tracking/trackingEventUtils';
import SkeletonLoadWrapper from '../common/loading/SkeletonLoadWrapper';
import { useErrorBoundary } from '../error-boundary/useErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BringAttention = styled.b.withConfig({
  displayName: "RequiredOnboardingSubtext__BringAttention",
  componentId: "sc-6ca3ii-0"
})([""]);
const RequiredOnboardingSubtext = ({
  skuIds,
  langKey,
  currencyCode,
  tab,
  trackingSource,
  includesOnboardingCost
}) => {
  var _pricingInfo$oneTimeF, _pricingInfo$oneTimeF2;
  const {
    showBoundary
  } = useErrorBoundary();
  const onboardingServicesUrl = getOnboardingServicesUrlPublic(HUBSPOT_FOR_STARTUPS_SETUP === langKey);
  const handleClick = () => {
    trackClickedLink({
      name: 'onboarding-services',
      value: getI18nText('planBuilder.requiredOnboardingSubtext.learnMore', {
        locale: 'en-us'
      }),
      type: 'external',
      url: onboardingServicesUrl,
      tab,
      trackingSource
    });
  };
  const onboardingIncludedKey = includesOnboardingCost ? 'onboardingIncluded' : 'onboardingNotIncluded';
  const productConfigurations = skuIds.map(skuId => createProductConfig({
    quantity: 1,
    skuId
  }));
  const {
    pricingData: pricingInfo,
    loading: pricingLoading,
    error: pricingError
  } = usePurchaseOptionsForProductsForTerm({
    productConfigurations
  });
  if (pricingError) {
    showBoundary(new CustomError('Error fetching required onboarding pricing data', {
      error: pricingError,
      productConfigurations
    }));
  }
  const fullPrice = pricingInfo === null || pricingInfo === void 0 || (_pricingInfo$oneTimeF = pricingInfo.oneTimeFee) === null || _pricingInfo$oneTimeF === void 0 ? void 0 : _pricingInfo$oneTimeF.fullPrice;
  const calculatedPrice = pricingInfo === null || pricingInfo === void 0 || (_pricingInfo$oneTimeF2 = pricingInfo.oneTimeFee) === null || _pricingInfo$oneTimeF2 === void 0 ? void 0 : _pricingInfo$oneTimeF2.calculatedPrice;
  if ((!(pricingInfo !== null && pricingInfo !== void 0 && pricingInfo.oneTimeFee) || !fullPrice || !calculatedPrice) && !pricingLoading) {
    return null;
  }
  return /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: pricingLoading,
    heights: [40],
    widths: ['100%'],
    children: /*#__PURE__*/_jsxs(Small, {
      children: [fullPrice && calculatedPrice && fullPrice > calculatedPrice ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: `planBuilder.requiredOnboardingSubtext.${onboardingIncludedKey}.${langKey}-with-discount_jsx`,
        options: {
          currencyCode,
          fullPrice,
          discountedPrice: calculatedPrice
        },
        elements: {
          PriceDisplay,
          CrossedOutPrice,
          b: BringAttention
        }
      }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: `planBuilder.requiredOnboardingSubtext.${onboardingIncludedKey}.${langKey}_jsx`,
        options: {
          currencyCode,
          price: calculatedPrice
        },
        elements: {
          PriceDisplay,
          b: BringAttention
        }
      }), ' ', /*#__PURE__*/_jsx(Link, {
        external: true,
        onClick: handleClick,
        href: onboardingServicesUrl,
        "aria-label": I18n.text(`planBuilder.requiredOnboardingSubtext.onboarding.${langKey}`),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "planBuilder.requiredOnboardingSubtext.learnMore"
        })
      })]
    })
  });
};
export default RequiredOnboardingSubtext;